import React from "react";
import {
  makeStyles,
  createStyles,
  withStyles,
  Theme
} from "@material-ui/core/styles";
import LinearProgress, {
  LinearProgressProps
} from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5
    },
    colorPrimary: {
      backgroundColor:
      theme.custom.colors.primaryColor
    },
    bar: {
      borderRadius: 5,
      backgroundColor: "#1a90ff"
    }
  })
)(LinearProgress);

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number }
) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" p={4} mr={1}>
        <Typography variant="h6">Uploading...</Typography>
        <BorderLinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles({
  root: {
    width: "100%"
  }
});

function PhotoProgressBar(props) { 
  
  const classes = useStyles();
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => (prevProgress >= 95 ? 95 : prevProgress + 5));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  if (props.isComplete === "true") {
  } else {
    return (
      <div className={classes.root}>
        <LinearProgressWithLabel value={progress} />
      </div>
    );
  }
}

export { PhotoProgressBar };
